// What the hand-off screens know about the packet's words (Stage 4.5). The actions are the framework's own (server/ai/actions.js
// TEMPLATES); one the screen has no words for is named by the business's own action name. scripts/check-handoffs.cjs proves
// every one listed here has words in five languages.
import { Ban, CalendarCheck, CalendarClock, ClipboardList, Pencil, Reply, Send, Ticket, UserPlus } from "lucide-react";

export const KNOWN_ACTIONS = [
  "take_order", "update_order", "cancel_order",
  "book_appointment", "reschedule_appointment", "cancel_appointment", "confirm_appointment",
  "schedule_follow_up", "cancel_follow_up", "request_callback",
  "create_ticket", "update_ticket", "close_ticket",
  "capture_lead", "update_contact", "add_note", "request_quote", "property_enquiry",
  "send_email", "send_whatsapp", "confirm_on_whatsapp",
];

export const PRIMITIVE_ICON = { create: ClipboardList, update: Pencil, cancel: Ban, notify: Send };
export const ACTION_ICON = {
  book_appointment: CalendarCheck, reschedule_appointment: CalendarClock, confirm_appointment: CalendarCheck,
  schedule_follow_up: Reply, request_callback: Reply, create_ticket: Ticket, capture_lead: UserPlus,
};
export const iconOfDone = (d) => ACTION_ICON[d?.action] ?? PRIMITIVE_ICON[d?.primitive] ?? ClipboardList;

// The words for one thing the assistant did: its own label, else the business's action name made readable.
export function doneLabel(d, t) {
  if (KNOWN_ACTIONS.includes(d?.action)) return t(`action.${d.action}`);
  return String(d?.action ?? "").replace(/_/g, " ");
}
